// react
import React, { useState, useEffect, useRef ,useContext } from 'react';
import { Map, View } from 'ol';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import {XYZ,CartoDB, OSM} from 'ol/source';
import {DoubleClickZoom} from 'ol/interaction';
import './MapView.css';
import {replaceBorderLayer,POI} from './MapViewAPI';
import PopUp from '../PopUp/PopUp';
import {stateBoundaryVectorSource, stateBoundaryStyle } from './boundary/state';
import Overlay from 'ol/Overlay';
import { AppContext } from '../../Context';
import _ from 'lodash';
function MapView(props) {

  // set intial state
  const [ map, setMap ] = useState();
  const [ view,setView ] = useState();
  const [extent,setExtent] = useState([]);
  const [currLayer,setCurrLayer] = useState();
  const {stateData,setStateData,mapData,setMapData,loader,setLoader} = useContext(AppContext);
  const [feature,setFeature] = useState();
  // pull refs

  const mapElement = useRef()
  const popupElement = useRef()
  const closerElement = useRef()
  useEffect(()=>{

    const ViewCurr = new View({
      projection: 'EPSG:4326',
      center: [82.79499799999996,22.455681],
      zoom: 4.4
    });
    setView(ViewCurr);
    const map = new Map({
      target: mapElement.current,
      layers: [
        new TileLayer({
          source: new OSM()
          // source: new XYZ({
          //   url: 'https://tile.stamen.com/toner/{z}/{x}/{y}.png',
          // }),
          // source: new XYZ({
          //   url: 'https://a.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png',
          //   attributions: '© CARTO',
          //   maxZoom: 19,
          //   subdomains: ['a', 'b', 'c', 'd'],
          //   style: 'light_all', // You can use 'dark_all', 'voyager', etc, rastertiles/voyager_nolabels, rastertiles/voyager_nolabels
          // }),
        })
      ],
      view: ViewCurr,
      controls: []
    })

    const overlay = new Overlay({
      element: popupElement.current,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });
  
    map.addOverlay(overlay);
    const adminBoundary = new VectorLayer();
    adminBoundary.setSource(stateBoundaryVectorSource);
    adminBoundary.setStyle(stateBoundaryStyle(stateData.optionSelection));
    setCurrLayer(adminBoundary);
    map.addLayer(adminBoundary);


    closerElement.current.onclick = function () {
      overlay.setPosition(undefined);
      closerElement.current.blur();
      return false;
    };
    
    // map.on('singleclick', function (evt) {
    //   const coordinate = evt.coordinate;
    //       map.forEachFeatureAtPixel(evt.pixel, function (f) {
    //         console.log('single click features...',f);
    //       setFeature(f);
    //     return true;
    //   });
    //   overlay.setPosition(coordinate);
    // });

    map.on("singleclick", function (evt) {
      const coordinate = evt.coordinate;
      map.forEachFeatureAtPixel(evt.pixel, function (f) {
        // console.log("FEATURESSSSS!", f);
        if (
          (f?.getGeometry().getType() === "Point" &&
            (f?.getProperties().hasOwnProperty("MSIL_CODE")||f?.getProperties().hasOwnProperty("dealer_name"))) ||
          ((f?.getGeometry().getType() === "MultiPolygon" || f?.getGeometry().getType() === "Polygon") && f?.getProperties().hasOwnProperty("STATE_NAME"))
        ) {
          console.log('single click If condition satisfied')
          overlay.setPosition(coordinate);
          setFeature(f);
          return true;
        } else {
          console.log('something else..')
          // closePopUp();
        }

        return false;
      });
    });


    map.on('dblclick',(evt)=>{
      const coordinate = evt.coordinate;
      map.forEachFeatureAtPixel(evt.pixel, function (f) {
        // console.log('dblclick',f);
        var dblclk_obj = {State: _.isEmpty(f.get('STATE_NAME')) ? '' : f.get('STATE_NAME'),
         District: _.isEmpty(f.get('DIST_NAME')) ? '' : _.replace(f.get('DIST_NAME'),' District',''), 
         Sub_District: _.isEmpty(f.get('SUBDIST_NAME')) ? '' : f.get('SUBDIST_NAME'), 
         Village: _.isEmpty(f.get('VIL_NAME')) ? '' : f.get('VIL_NAME')};
        //  console.log(dblclk_obj);
         setStateData({...stateData,'selected' : dblclk_obj});
        
        //setFeature(f);
      return true;
    });
      // console.log('double click is called',coord,evt);
      // console.log(boundaryVectorLayer.getSource().getClosestFeatureToCoordinate(coord));
  });

  var dblClickInteraction;
  // find DoubleClickZoom interaction
  map.getInteractions().getArray().forEach(function(interaction) {
    if (interaction instanceof DoubleClickZoom) {
      dblClickInteraction = interaction;
    }
  });
  // remove from map
  map.removeInteraction(dblClickInteraction);
    setMap(map);
    
    setMapData({...mapData,'mapObject' : map});
    // console.log("Debug 4",stateData);
    return () => map.setTarget(undefined);
  },[]);



useEffect(()=>{
  var selected = stateData.selected;
  // console.log("replaceBorderLayer called");
  if(!_.isUndefined(map))
    replaceBorderLayer(map,setMap,selected,currLayer,setCurrLayer,extent,setExtent,loader,setLoader,stateData?.optionSelection);
    
  //setMapData({...mapData,'mapObject' : map});
  // console.log("Debug 2->",map);
 // setStateData({...stateData,'mapObject' : map});
  // setStateData((previousStateData)=>({...previousStateData,'mapObject': map}));
},[stateData?.selected]);

useEffect(()=>{
  let tempStateData=stateData;
  if(!_.isUndefined(map)){
    tempStateData.mapObject=map;
  }
  //  console.log("Debug 3",map);
   setStateData({...tempStateData});
   setMapData({...mapData,'mapObject' : map});
},[map,stateData.selected,stateData?.optionSelection])
// if(boundaryVectorLayer.getExtent()!==ext){
//                     map.getView().fit(ext, { duration: 2000 , padding: [50, 50, 50, 50]});
// }
// useEffect(()=>{
//   console.log("Debug 5->",stateData)
// },[stateData])
// useEffect(()=>{
// //console.log(extent);
// console.log('curr_layer_url->',currLayer?.getSource().getUrl());
// //if(_.filter(map?.getAllLayers(),(l)=>{return l === currLayer}).length > 0){
//   //layer
//   if(!_.isEmpty(extent)){
//     view.fit(extent, { duration: 2000 , padding: [50, 50, 50, 50]});
//     map.setView(view);
//     console.log('change view called:-',view);
//    }
// //}

//    //map.getView().fit(extent, { duration: 2000 , padding: [50, 50, 50, 50]});
// },[currLayer?.getSource().getUrl()]);

useEffect(()=>{
  currLayer?.setStyle(stateBoundaryStyle(stateData?.optionSelection));
},[stateData.optionSelection]);

useEffect(()=>{
  if(!_.isEmpty(stateData?.mapObject))
  {
    // console.log("stateData.mapObject",stateData.mapObject);
    setMap(stateData?.mapObject);
  }

},[stateData?.mapObject]);


  return (
      <>
      <div ref={mapElement} className="map-container"></div>
      <PopUp popupElement = {popupElement}
       closerElement = {closerElement} 
       POI = {POI} f = {feature} popUpType = "boundary"/>
      </>
  )

}

export default MapView;